import APIKit from "../Allapis/Apikit/apikit";

export const getAllTransactions = async (body) => {
  let results;
  try {
    const url = `/transactions/allTransactons`;
    results = await APIKit.put(url, body);
    return results.data;
  } catch (e) {
    console.log(e);
    return e.response ? e.response.data : e;
  }
};
